import React, { Component, PropTypes } from 'react'
import moment from 'moment-timezone'

import './CalendarDay.scss'
import LabeledIcon from 'components/LabeledIcon'
import CalendarModal from './components/CalendarModal'
import { formatDate } from 'utils/dates'
import { HORIZON_DAYS } from '@src/globals'

class CalendarDay extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false,
      value: moment(0)
    }

    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.updateDate = this.updateDate.bind(this)
    this.confirmDate = this.confirmDate.bind(this)
  }

  open () {
    this.setState({
      modalIsOpen: true
    })
  }

  close () {
    this.setState({
      modalIsOpen: false
    })
  }

  updateDate (date) {
    this.setState({
      value: date
    })
  }

  confirmDate (date) {
    this.updateDate(date)
    this.props.onChange(date)
    this.close()
  }

  render () {
    const {
      modalIsOpen,
      value
    } = this.state

    const {
      selectedDate,
      minDate,
      maxDate
    } = this.props

    const selectedDateIsSameDateAsCalendar = selectedDate.isSame(value, 'day')
    const labeledIconProps = {
      selected: selectedDateIsSameDateAsCalendar,
      onClick: this.open,
      label: selectedDateIsSameDateAsCalendar ? formatDate('MMMM', value) : 'Ver más',
      iconType: selectedDateIsSameDateAsCalendar ? 'text' : 'icon',
      iconContent: selectedDateIsSameDateAsCalendar ? formatDate('D', value) : 'calendar'
    }

    return (
      <div className='CalendarDay'>
        <CalendarModal
          isOpen={modalIsOpen}
          onRequestClose={this.close}
          onDateSelected={this.confirmDate}
          minDate={minDate}
          maxDate={maxDate}
          />
        <LabeledIcon {...labeledIconProps} />
      </div>
    )
  }
}

CalendarDay.displayName = 'CalendarDay'
CalendarDay.propTypes = {
  selectedDate: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object
}
CalendarDay.defaultProps = {
  selectedDate: moment(0),
  minDate: moment(),
  maxDate: moment().add(HORIZON_DAYS, 'days')
}

export default CalendarDay



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/DateTimeForm/components/DateSelector/components/CalendarDay/CalendarDay.js